<template>
  <div style="padding:8px 4px;">
    <div v-if="loading" style="padding:32px 0;text-align:center;opacity:0.4;font-size:14px;">불러오는 중…</div>
    <div v-else>
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:18px;">
        <div style="font-size:13px;">동영상이 이 저작물과 일치할 때:</div>
        <el-button size="mini" plain @click="openEdit" style="color:#7367F0;border-color:#7367F0;">정책 수정</el-button>
      </div>

      <PolicyRules :rules="rules"></PolicyRules>

      <div v-if="savedAs" style="margin-top:24px;padding-top:12px;border-top:1px solid rgba(0,0,0,0.06);opacity:0.5;font-size:12px;">
        저장된 정책 <span style="opacity:1;margin-left:6px;font-family:monospace;">{{ savedAs }}</span>
      </div>
    </div>

    <ConfirmActionDialog
      :visible.sync="dialogOpen"
      title="일치 정책 업데이트"
      :confirm-token="assetId"
      confirm-label="정책 적용"
      :submitting="submitting"
      @confirm="onConfirm"
    >
      <template #subject>
        저작물 <strong>{{ assetId }}</strong>
      </template>
      <template #diff>
        <PolicyRulesDiff :before="rules" :after="proposedRules"></PolicyRulesDiff>
        <div style="margin-top:12px;display:flex;flex-direction:column;gap:6px;">
          <label style="opacity:0.5;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:0.6px;">저장된 정책 적용</label>
          <el-select v-model="selectedPolicyId" placeholder="정책 선택" filterable @change="onPolicyChange">
            <el-option v-for="p in policies" :key="p.id" :label="p.name || p.id" :value="p.id"></el-option>
          </el-select>
        </div>
      </template>
    </ConfirmActionDialog>
  </div>
</template>

<script>
import { YoutubeCidApi } from '../api.js'
import PolicyRules from '../components/PolicyRules.vue'
import PolicyRulesDiff from '../components/PolicyRulesDiff.vue'
import ConfirmActionDialog from '../components/ConfirmActionDialog.vue'

export default {
  name: 'AssetMatchPolicyTab',
  components: { PolicyRules, PolicyRulesDiff, ConfirmActionDialog },
  props: {
    assetId: { type: String, required: true },
    matchPolicy: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      submitting: false,
      policies: [],
      dialogOpen: false,
      selectedPolicyId: '',
      proposedRules: [],
    }
  },
  computed: {
    rules() { return (this.matchPolicy && this.matchPolicy.rules) || [] },
    savedAs() { return this.matchPolicy && (this.matchPolicy.policyName || this.matchPolicy.policyId) },
  },
  methods: {
    async openEdit() {
      this.dialogOpen = true
      if (!this.policies.length) {
        const data = await YoutubeCidApi.listPolicies().catch(() => null)
        this.policies = (data && data.items) || []
      }
    },
    async onPolicyChange(id) {
      const p = await YoutubeCidApi.getPolicy(id).catch(() => null)
      this.proposedRules = (p && p.rules) || []
    },
    async onConfirm() {
      if (!this.selectedPolicyId) return
      this.submitting = true
      try {
        await YoutubeCidApi.updateMatchPolicy(this.assetId, { policyId: this.selectedPolicyId })
        this.dialogOpen = false
        this.selectedPolicyId = ''
        this.proposedRules = []
        this.$emit('updated')
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>
